module.exports = __webpack_public_path__ + "img/logo.1374f095.png";